import KlarityServices from 'components/ApplicationFormComponents/KlarityServices';
import useFetchProvider from 'hooks/useFetchProvider';
import useGetProviderAllInsurance from 'hooks/useGetProviderAllInsurance';
// import useKlarityProgram from 'hooks/useKlarityProgram';
import React, { useCallback, useEffect, useState } from 'react';
import { EProviderType } from 'types/provider';
import s from './s.module.less';
import { useNavigate } from 'react-router-dom';
import { PATH } from 'constants/path';
import { EModalMode } from 'components/ApplicationFormComponents/KlarityServices/types';
import { Spin } from 'antd';
import useProviderHomeInfo from 'hooks/useProviderHomeInfo';

const ServiceSettingPage = () => {
    const isOps = false;
    const isReviewStep = false;
    const navigate = useNavigate();
    const [provider, loading] = useFetchProvider();
    const [homeInfo, loadingHome] = useProviderHomeInfo();
    const providerId = provider?.id;
    // const [allPrograms, klarityProgramloading, refetchProgram] = useKlarityProgram(isOps, providerId);
    const [uniprofileInsuranceData, loadingInsurance] = useGetProviderAllInsurance(providerId, isOps);
    const [currentStep, setCurrentStep] = useState<EModalMode>(EModalMode.SELECT_SPECIALTY);
    // const [isSpecialtyiesEnd, setIsSpecialtyiesEnd] = useState<boolean>(false);
    const [settingIsDone, setSettingIsDone] = useState<boolean>(false);

    const handleSaveSuccessfully = useCallback(() => {
        setSettingIsDone(true);
    }, []);

    useEffect(() => {
        setSettingIsDone(!!homeInfo?.klarityServiceSetUpCompleted);
    }, [homeInfo]);

    const onExit = useCallback(() => {
        navigate(`${PATH.DASHBOARD}`);
    }, [navigate]);

    const spinning = loading || loadingInsurance || loadingHome;
    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <img
                    onClick={() => {
                        navigate(`${PATH.DASHBOARD}`);
                    }}
                    src="https://saas-prod-us.s3.us-east-2.amazonaws.com/prod/ui/logo_kiwihealth_by_klarity_380x96.png"
                    className={s.logo}
                />
            </div>
            <Spin spinning={spinning}>
                <div className={s.inner}>
                    <KlarityServices
                        addressList={provider?.practice?.addressList || []}
                        uniprofileInsuranceData={uniprofileInsuranceData}
                        onSaveSuccessfully={handleSaveSuccessfully}
                        hideAvaTip
                        setIsSpecialtyiesEnd={setSettingIsDone}
                        layerNextBtnText="Select service templates"
                        isServiceSetting
                        layerFootWrapClass={s.layerFootWrap}
                        settingIsDone={settingIsDone}
                        provider={provider}
                        providerType={EProviderType.KIWI}
                        isReviewStep={isReviewStep}
                        isOps={isOps}
                        providerId={providerId}
                        onLayerBackClick={onExit}
                        setCurrentStep={setCurrentStep}
                        fullWidthFooter
                    />
                </div>
            </Spin>
        </div>
    );
};

export default ServiceSettingPage;
